const theme = {
  color: {
    accentGreen: '#0CD4AF',
    accentPurple: '#6876CB',
    secondaryPurple: '#5B66AC',
    hoverGreen: '#0bc1a0',
    hoverPurple: '#5969c6',
    lightGreen: '#e2fdf8',
    lightPurple: '#F4F6FF',
    textColor: '#333', //main text color
    accentText: '#6876CB',
    footerText: '#c7ccec',
    white: '#FFFFFF',
    offWhite: '#F2F2F2',
  },

  shadow: {
    cardShadow: '0 16px 48px rgba(32, 41, 50, 0.21)',
    containerShadow: '0 0 2px 0 rgba(0, 0, 0, 0.19)',
    buttonHover: '0 3px 10px rgba(0, 0, 0, 0.15)',
    buttonShadow: '0 0 3px 0 rgba(0, 0, 0, 0.19)',
  },

  font: {
    fontFamily: "'Lato', sans-serif",
  },

  fontSize: {
    xxxs: '0.875rem',
    xxs: '1.2rem',
    message: '1.4rem',
    xs: '1.6rem',
    s: '1.8rem',
    sm: '2rem',
    m: '2.4rem',
    l: '3rem',
    xl: '3.5rem',
  },

  fontStyle: {
    italic: 'italic',
  },

  textTransform: {
    uppercase: 'uppercase',
  },

  fontWeight: {
    bold: 'bold',
    bolder: 'bolder',
  },

  border: {
    radius: '5px',
  },

  input: {
    height: '40px',
  },

  button: {
    height: '48px',
    smallButton: '30px',
  },

  spinner: {
    diameter: '30px',
  },

  spacing: {
    lineHeight: '1.5',
    letterSpacing: '0.1rem',
  },
};

export default theme;
